import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import { ValidateInputs } from "../../utils/helper";

const ForgotPasswordToken = () => {
  const { AsyncPostApiCall } = useApi();
  const { token } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [payload, setPayload] = useState({
    verificationToken: token || "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleValues = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
    const updatedInputs = ValidateInputs(name, value, errors);
    setErrors(updatedInputs);
  };

  const validate = () => {
    const newErrors = {};

    // Check if password is empty
    if (!payload.newPassword.trim()) {
      newErrors.newPassword = "Password is required";
    } else if (payload.newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters long";
    } else if (!/[A-Z]/.test(payload.newPassword)) {
      newErrors.newPassword =
        "Password must contain at least one uppercase letter";
    } else if (!/[a-z]/.test(payload.newPassword)) {
      newErrors.newPassword =
        "Password must contain at least one lowercase letter";
    } else if (!/[0-9]/.test(payload.newPassword)) {
      newErrors.newPassword = "Password must contain at least one number";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(payload.newPassword)) {
      newErrors.newPassword =
        "Password must contain at least one special character";
    }

    if (!payload.confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (payload.newPassword !== payload.confirmPassword) {
      newErrors.confirmPassword = "Passwords don't match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetApiCall = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    if (payload.newPassword !== payload.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const result = await AsyncPostApiCall("/admin/reset-password", payload);

    if (result.errors) {
      toast.error(result.errors[0]);
    } else if (result.success) {
      toast.success("Password reset successful");
      setPayload({
        verificationToken: token || "",
        newPassword: "",
        confirmPassword: "",
      });
      setErrors({});
      navigate("/sign-in");
    }
  };
  return (
    <>
      <section className="auth forgot-password-page bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="assets/images/auth/forgot-pass-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <h4 className="mb-12">Reset Password</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Enter the email address associated with your account and we will
                send you a link to reset your password.
              </p>
            </div>
            <form onSubmit={resetApiCall}>
              <div className="icon-field" style={{ display: "flex" }}>
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  name="newPassword"
                  type={showPassword ? "text" : "password"}
                  value={payload?.newPassword}
                  onChange={handleValues}
                  className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.newPassword ? "is-invalid" : ""
                    }`}
                  placeholder="New Password"
                // required
                />
                <button
                  type="button"
                  className="absolute right-[15px] top-[33px] text-[28px] text-black-900"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon
                    icon={
                      showPassword ? "solar:eye-closed-bold" : "solar:eye-bold"
                    }
                    className="text-xl"
                  />
                </button>
                <br />
                {errors.newPassword && (
                  <div className="invalid-feedback">{errors.newPassword}</div>
                )}
              </div>
              <div
                className="icon-field mb-16 mt-20"
                style={{ display: "flex" }}
              >
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={payload.confirmPassword}
                  onChange={handleValues}
                  className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.confirmPassword ? "is-invalid" : ""
                    }`}
                  placeholder="Confirm Password"
                // required
                />
                <button
                  type="button"
                  className="absolute right-[15px] top-[33px] text-[28px] text-black-900"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <Icon
                    icon={
                      showConfirmPassword
                        ? "solar:eye-closed-bold"
                        : "solar:eye-bold"
                    }
                    className="text-xl"
                  />
                </button>
                <br />
                {errors.confirmPassword && (
                  <div className="invalid-feedback">
                    {errors.confirmPassword}
                  </div>
                )}
              </div>
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                Reset Password
              </button>
              <div className="text-center">
                <Link to="/sign-in" className="text-primary-600 fw-bold mt-24">
                  Back to Sign In
                </Link>
              </div>
              <div className="mt-120 text-center text-sm">
                <p className="mb-0">
                  Already have an account?{" "}
                  <Link to="/sign-in" className="text-primary-600 fw-semibold">
                    Sign In
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
      {/* Modal */}
      {/* <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-40 text-center">
              <div className="mb-32">
                <img src="assets/images/auth/envelop-icon.png" alt="" />
              </div>
              <h6 className="mb-12">Verify your Email</h6>
              <p className="text-secondary-light text-sm mb-0">
                Thank you, check your email for instructions to reset your
                password
              </p>
              <button
                type="button"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                Skip
              </button>
              <div className="mt-32 text-sm">
                <p className="mb-0">
                  Don’t receive an email?{" "}
                  <Link to="/resend" className="text-primary-600 fw-semibold">
                    Resend
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ForgotPasswordToken;
